import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { Divider } from "antd";
import React from "react";
import { labels } from "../../../localization/labels";
import GenericTree from "../GenericTree";
import SubmitControl from "../SubmitControl/SubmitControl";

const SearchTree = props => {
  return (
    <div className={props.className}>
      <Divider orientation="left">{props.title}:</Divider>

      {props.searchable ? (
        <SubmitControl
          disableable={false}
          style={{ marginBottom: 8 }}
          type="search"
          placeholder={labels.search}
          onChange={props.onSearchChange}
          value={props.searchValue}
        />
      ) : null}
      <GenericTree
        checkedKeys={props.checkedKeys}
        onCheck={props.onCheck}
        ref={props.treeRef}
        data={props.data}
        loadedKeys={props.loadedKeys}
        loadData={props.loadData}
        draggable={false}
        onClick={props.onClick}
        pageInfo={props.pageInfo}
        onPageNumberClick={props.onPageNumberClick}
        fontAwesomeIcon={faPlusCircle}
        checkable={props.checkable}
      />
    </div>
  );
};

export default SearchTree;
